import { createTheme } from '@mui/material/styles';

/**
 * Forced LIGHT MUI theme for the unauthenticated funnel (login / registro /
 * no-access). The app's global theme follows uiStore.colorMode (default dark),
 * which renders MUI form fields as light-on-light on these cream cards — the
 * inputs effectively disappear. Wrapping these pages in this theme fixes it and
 * makes primary (buttons, stepper, focus) the Teach emerald.
 */
export const authTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0f766e', contrastText: '#ffffff' },
    secondary: { main: '#10b981' },
    background: { default: '#f6f4ee', paper: '#fffdf8' },
    text: { primary: '#13201d', secondary: 'rgba(19,32,29,0.6)' },
  },
  shape: { borderRadius: 12 },
});
